import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LayersIcon from "@mui/icons-material/Layers";

// In-progress product page — deliberately no email signup / "notify me"
// form here, unlike the old NephroTrax "coming soon" treatment this is
// modeled on. That pattern implied a specific, imminent launch date;
// ResourceClan doesn't have one to promise yet.
export default function ResourceClanPage() {
  const features = [
    {
      icon: <SearchIcon sx={{ fontSize: 40 }} />,
      title: "Local Resource Directory",
      description:
        "A searchable directory of social-services resources — not tied to one specific disease community, unlike our other platforms.",
    },
    {
      icon: <LocationOnIcon sx={{ fontSize: 40 }} />,
      title: "Community Services Search",
      description:
        "Find local support services by need and location, in one search rather than piecing information together from multiple sources.",
    },
    {
      icon: <LayersIcon sx={{ fontSize: 40 }} />,
      title: "Built on a Proven Foundation",
      description:
        "Built on the same platform architecture already powering AmyloidConnect, NephroTrax, and Compass in production.",
    },
  ];

  return (
    <Box>
      {/* HERO */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #5B21B6 0%, #4C1D95 100%)",
          color: "white",
          py: { xs: 10, md: 16 },
          textAlign: "center",
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ color: "rgba(255,255,255,0.9)", mb: 3 }}>
            <VolunteerActivismIcon sx={{ fontSize: 80 }} />
          </Box>

          <Chip
            label="In Progress"
            sx={{
              bgcolor: "#f9a825",
              color: "#1a237e",
              fontWeight: 800,
              fontSize: "1rem",
              px: 2,
              py: 2.5,
              mb: 3,
            }}
          />

          <Typography variant="h2" fontWeight={800} gutterBottom>
            ResourceClan
          </Typography>

          <Typography
            variant="h5"
            sx={{ opacity: 0.9, mb: 2, fontWeight: 400 }}
          >
            Social Services Resource Directory
          </Typography>

          <Typography
            variant="h6"
            sx={{
              opacity: 0.8,
              fontWeight: 400,
              maxWidth: 600,
              mx: "auto",
              lineHeight: 1.7,
            }}
          >
            A general-purpose resource directory connecting anyone — not just
            a specific patient community — with the local support services
            they need. Currently in development.
          </Typography>
        </Container>
      </Box>

      {/* WHAT'S PLANNED */}
      <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: "#f8fafc" }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip
              label="In Development"
              sx={{
                bgcolor: "rgba(91,33,182,0.1)",
                color: "#5B21B6",
                fontWeight: 600,
                mb: 2,
              }}
            />
            <Typography variant="h3" fontWeight={700} gutterBottom>
              What We're Building
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    height: "100%",
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    border: "2px solid transparent",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: 4,
                      borderColor: "#5B21B6",
                    },
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ color: "#5B21B6", mb: 2 }}>{feature.icon}</Box>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ lineHeight: 1.7 }}
                    >
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}